import React from "react";
import {Link} from "react-router-dom";

const Button = ({
                    type = "button",
                    style,
                    as = "button",
                    onClick,
                    children,
                    disabled = false,
                    size = "normal",
                    extraClasses = "",
                    ...rest
                }) => {
    const basePadding = size === "small" ? "py-1 px-2" : "py-2 px-4"

    const baseClasses = `${basePadding} inline-flex items-center justify-center rounded uppercase text-xs font-bold tracking-wide transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`
    const disabledClasses = `${basePadding} inline-flex items-center justify-center rounded uppercase text-xs font-bold tracking-wide cursor-not-allowed`

    const getStyleClasses = (isDisabled) => {
        if (isDisabled) {
            return "bg-gray-300 text-gray-400"
        }

        if (style === "muted") {
            if (as === "Link") {
                return "bg-gray-500 text-slate-100 hover:bg-blue-600 hover:text-white opacity-90"
            }
            return "bg-transparent text-slate-500 hover:bg-white hover:text-slate-700 hover:ring"
        }

        if (style === "secondary") {
            return "bg-transparent text-slate-500 hover:bg-blue-600 border-2 border-slate-500 hover:text-slate-100 hover:border-blue-600"
        }

        // Primary (default)
        return "bg-slate-600 hover:bg-blue-600 text-slate-100"
    }

    const classes = disabled
        ? `${disabledClasses} ${getStyleClasses(true)} ${extraClasses}`
        : `${baseClasses} ${getStyleClasses(false)} ${extraClasses}`

    if (as === "Link") {
        return (
            <Link className={classes} {...rest}>
                {children}
            </Link>
        )
    }

    return (
        <button
            type={type}
            className={classes}
            onClick={onClick}
            disabled={disabled}
            {...rest}
        >
            {children}
        </button>
    )
}

export default Button;
